"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.shouldFilterOutDataRow = exports.validateTransform = void 0;
const common_1 = require("@finley-technologies/common");
const errorUtils_1 = require("./errorUtils");
const validateTransform = (_transformation) => {
    // since this is pre-sanitize operation there
    // is not much to validate here.
    return { isValid: true, data: null };
};
exports.validateTransform = validateTransform;
const shouldFilterOutDataRow = (params) => {
    const { csvRow, transformation } = params;
    const shouldFilterOut = transformation.exclude.some((exclude) => {
        const { field, values } = exclude;
        (0, common_1.finleyAssert)(field in csvRow, `Field [${field}] does not exist in input tape`);
        const rowValue = csvRow[field];
        // Can assume we're not filtering out the row if the target value is
        // empty for now. Can adjust config / logic here if we want to exclude
        if (rowValue === undefined) {
            return false;
        }
        return values.includes(rowValue);
    });
    return shouldFilterOut;
};
exports.shouldFilterOutDataRow = shouldFilterOutDataRow;
const performTransform = async (params) => {
    try {
        const { dataTapeBuffers, transformation } = params;
        (0, common_1.finleyAssert)(dataTapeBuffers.length === 1, 'Expected 1 data tape buffer');
        const srcDataTapeBuffer = dataTapeBuffers[0];
        const { data } = common_1.csvConversion.csvBufferToJsonArray({
            csvBuffer: srcDataTapeBuffer,
        });
        // filter by exclude config
        const filteredData = data.filter((csvRow) => {
            const shouldFilterOut = shouldFilterOutDataRow({
                csvRow,
                transformation,
            });
            return !shouldFilterOut;
        });
        const outputBuffer = common_1.csvConversion.csvArrayToFinleyBuffer({
            csvArray: filteredData,
        });
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'preFilter: ');
    }
};
exports.transformOperation = {
    operation: 'preFilter',
    validateTransform: exports.validateTransform,
    performTransform,
};
//# sourceMappingURL=preFilter-transform.js.map